// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'snippets/swiper-control/swiper-control';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_featured-collection.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--featured-collection';
const CAROUSEL_CLASS = 'carousel--featured-collection';
const CAROUSEL_SECTION_SELECTOR = '.featured-collection';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)?.forEach((element, index) => {
    // Generate unique class for each collection list slider
    element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

    // Generate unique btn classes for slider arrows
    element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_CLASS}-btn-prev-${index}`);
    element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_CLASS}-btn-next-${index}`);

    // Generate unique btn classes for swiper pagination
    element.querySelector(CAROUSEL_PAGINATION_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-pagination-${index}`);

    const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
            // when window width is >= 680px
            680: {
                slidesPerView: 2.1,
            },
            // when window width is >= 1024
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        },

        navigation: {
            nextEl: `.${CAROUSEL_CLASS}-btn-next-${index}`,
            prevEl: `.${CAROUSEL_CLASS}-btn-prev-${index}`
        },

        pagination: {
            el: `.${CAROUSEL_CLASS}-pagination-${index}`,
            type: 'bullets',
            clickable: true,
        },
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');
        slideLink?.addEventListener('focus', function() {
            swiper.slideTo(index);
        });
    });
});
